import script from "./AccountInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountInfo.vue?vue&type=script&setup=true&lang=js"

import "./AccountInfo.vue?vue&type=style&index=0&id=42f4a1dd&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f4a1dd"]])

export default __exports__